export const PERCENTAGE_BREAKDOWN_PARTS = [
  'container',
  'bar',
  'barSegment',
  'tooltip',
  'tooltipItem',
  'tooltipItemDot',
  'tooltipItemLabel',
  'tooltipItemValue',
  'tooltipMessage',
] as const;
